/**
 * 首字母头像。
 *
 * v1 **刻意没有头像上传**（spec §3.1：头像会拖出「头像给谁看」这个可见性
 * 问题）。用昵称首字母 + 两种底色（我=蓝、TA=粉）代替 —— 认得出谁是谁就够了。
 */
export function Avatar({
  name,
  variant,
  size = 28,
}: {
  name: string | null | undefined;
  variant: "me" | "ta";
  size?: 28 | 36 | 40;
}) {
  const initial = name?.trim().slice(0, 1) ?? "?";
  return (
    <span
      className={`avatar avatar-${size} avatar-${variant}`}
      aria-hidden="true"
    >
      {initial}
    </span>
  );
}
